import { LGraphNode, LiteGraph } from "litegraph.js";
import { addDrivableSlider, finalizeDrivableSliders, syncDrivableSliders } from "../utils/addDrivableSlider.js";

export class BounceNode extends LGraphNode {
  constructor() {
    super();
    this.title = "Bounce";

    this.properties = {
      enabled: this.getUrlParam("bounceEnabled") !== "false",
      width: parseInt(this.getUrlParam("bounceWidth")) || 6,
      height: parseInt(this.getUrlParam("bounceHeight")) || 6,
      speed: parseInt(this.getUrlParam("speed")) || 50,
    };

    this.angle = 0;

    this._canvas = document.createElement("canvas");
    this._ctx = this._canvas.getContext("2d");

    // Regular inputs
    this.addInput("Canvas", "canvas");
    this.addInput("Offset X", "number");
    this.addInput("Offset Y", "number");

    // Output
    this.addOutput("Canvas", "canvas");

    // Non-drivable widget
    this.addWidget("toggle", "Enable", this.properties.enabled, (val) => {
      this.properties.enabled = val;
      this.updateUrlParam("bounceEnabled", val);
    });

    // Drivable sliders — input dots sit on each slider
    addDrivableSlider(this, "Width", "width", this.properties.width, 0, 200, 1, (val) => {
      this.updateUrlParam("bounceWidth", Math.round(val));
    });

    addDrivableSlider(this, "Height", "height", this.properties.height, 0, 200, 1, (val) => {
      this.updateUrlParam("bounceHeight", Math.round(val));
    });

    addDrivableSlider(this, "Speed", "speed", this.properties.speed, 1, 300, 1, (val) => {
      this.updateUrlParam("speed", Math.round(val));
    });

    // Position drivable inputs at their widgets (3 visible inputs: Canvas, Offset X, Offset Y)
    finalizeDrivableSliders(this, 3);

    this.size = [200, 160];
    this.mode = LiteGraph.ALWAYS;
    this.color = "#2a2a2a";
    this.bgcolor = "#333333";
  }

  getUrlParam(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }

  updateUrlParam() {}

  onExecute() {
    // Sync drivable sliders (Width/Height/Speed animate when driven)
    syncDrivableSliders(this);

    const input = this.getInputData(0);
    if (!input) {
      this.setOutputData(0, null);
      return;
    }

    this.angle += this.properties.speed / 2000;

    const offsetX = this.getInputData(1);
    const offsetY = this.getInputData(2);

    const bx = this.properties.enabled
      ? (offsetX != null ? offsetX : 0) + Math.sin(this.angle) * this.properties.width
      : 0;
    const by = this.properties.enabled
      ? (offsetY != null ? offsetY : 0) + Math.cos(this.angle) * this.properties.height
      : 0;

    // Pass the canvas straight through — no pixel copying.
    // Attach bounce offset as metadata for downstream (GridAnimator applies it).
    input.bounceOffset = { x: bx, y: by };

    this.setOutputData(0, input);
  }
}

LiteGraph.registerNodeType("transform/Bounce", BounceNode);
